import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  Output,
  EventEmitter
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store, select } from '@ngrx/store';
import * as fromRoot from '@core/reducers/root.reducer';
import * as fromFollow from '@app/modules/follow/reducers/follow.reducer';
import * as fromFollowDetail from '@app/modules/follow-detail/reducers/follow-detail.reducer';
import * as ProviderActions from '@core/actions/provider.actions';
import * as BrandActions from '@core/actions/brand.actions';
import * as UserActions from '@core/actions/user.actions';
import * as ProductActions from '@core/actions/product.actions';
import * as AutocompleteActions from '@app/modules/core/actions/autocomplete.actions';
// import * as FilterActions from '@core/actions/filter.actions';
import { FormBuilder } from '@angular/forms';
import { merge, take, takeWhile, observeOn } from 'rxjs/operators';
import { Observable, BehaviorSubject } from 'rxjs';
// import { Observable } from 'rxjs/observable';

@Component({
  selector: 'app-advanced-filter',
  templateUrl: './advanced-filter.component.html',
  styleUrls: ['./advanced-filter.component.css']
})
export class AdvancedFilterComponent implements OnInit, OnDestroy {
  selectedValue;
  items$;
  title;
  filteredSeason = [];
  season;
  advancedFilters;
  FollowId: number;
  providers = [];
  provi = [];

  @Output()
  filters = new EventEmitter();

  // @HostListener('document:keydown', ['$event'])
  // onKeyDownHandler(event: KeyboardEvent) {
  //   if (event.key === 'Escape') {
  //     this.activeModal.close();
  //   }
  // }

  _bol = false;
  providers$ = this.store.pipe(select(fromRoot.getProvidersPopulated));
  brands$ = this.store.pipe(select(fromRoot.getBrands));
  seasons$ = this.store.pipe(select(fromRoot.getProductSeasonsAC));
  collections$ = this.store.pipe(select(fromRoot.getProductCollectionsAC));
  tags$ = this.store.pipe(select(fromRoot.getProductTagsAC));
  // users$ = this.store.pipe(select(fromRoot.getUserRegionalFollow));
  members$ = this.store.pipe(select(fromFollow.getRegionalBuyerMembers));
  departments$ = this.store.pipe(
    select(fromFollowDetail.getAvailableSubDepartments)
  );
  selectedFilter;
  filterArea;
  products;
  filter$;
  currentProviders = [];
  users;
  regionalBuyers;
  key = '';
  value: '';
  _alive = true;
  productFields = [
    { name: 'Proveedor', value: 'ProviderId', key: 'id', display: 'name' },
    { name: 'Marca', value: 'BrandId', key: 'id', display: 'name' },
    { name: 'Temporada', value: 'season', key: 'id', display: 'name' },
    { name: 'Colección', value: 'collection', key: 'id', display: 'name' },
    { name: 'Tag', value: 'tag', key: 'id', display: 'name' },
    { name: 'Jerarquía', value: 'DepartmentId', key: 'id', display: 'name' },
    {
      name: 'Comprador regional',
      value: 'BuyerId',
      key: 'id',
      display: 'firstName'
    }
  ];

  providersTwo$ = new BehaviorSubject([]);

  constructor(
    public activeModal: NgbActiveModal,
    private store: Store<any>,
    public fb: FormBuilder
  ) {}

  ngOnDestroy() {
    this._alive = false;
  }

  ngOnInit() {
    this.store.dispatch(new ProviderActions.Load());
    this.store.dispatch(new BrandActions.Load());
    this.store.dispatch(new UserActions.Load());
    this.store.dispatch(new AutocompleteActions.LoadCollections(this.FollowId));

    this.store.dispatch(new AutocompleteActions.LoadTags(this.FollowId));

    this.provi = this.products
      .map(item => item.ProviderId)
      .filter((value, index, self) => self.indexOf(value) === index);

    this.providers$.pipe(takeWhile(() => this._alive)).subscribe(provider => {
      this.providers = this.provi.reduce((acc, pro) => {
        const found = provider.find(p => p.id === pro);
        if( found ){
          acc.push(found)
        }

        return acc
      }, []);
      this.providersTwo$.next(this.providers);
    });

    // console.log(this.provi);
    // console.log(this.provi.length);
  }

  isUsed(filter) {
    return (
      this.advancedFilters &&
      this.advancedFilters.map(f => f.key).includes(filter.name)
    );
  }

  selectKey(e) {
    this.key = e.target.value;
    this.value = '';
    if (this.key === 'ProviderId') {
      this.items$ = this.providersTwo$;
    } else if (this.key === 'BrandId') {
      this.items$ = this.brands$;
    } else if (this.key === 'season') {
      this.items$ = this.seasons$;
    } else if (this.key === 'collection') {
      this.items$ = this.collections$;
    } else if (this.key === 'BuyerId') {
      this.items$ = this.members$;
    } else if (this.key === 'tag') {
      this.items$ = this.tags$;
    } else if (this.key === 'DepartmentId') {
      this.items$ = this.departments$;
    }
  }

  selectValue(e) {
    this.value = e.target.value;
  }

  addAndDismiss() {
    if (this.key && this.value) {
      const productField = this.productFields.find(f => f.value === this.key);

      // this.selectedFilter = {
      //   condition: this.key,
      //   valueCondition: this.value
      // };

      // this.emitEvent.emit(this.advancedFilters);

      let value;
      let item;

      // if (this.value === 'empty') {
      //   value = null;

      //   // this.filter = {};

      //   // this.store.dispatch(
      //   //   new FilterActions.AddAdvancedFilter({
      //   //     condition: this.key,
      //   //     valueCondition: this.value,
      //   //     type: 'minimal'
      //   //   })
      //   // );

      //   this.store.dispatch(
      //     new FilterActions.AddAdvancedFilter({
      //       key: this.key,
      //       value,
      //       keyName: productField.name,
      //       displayValue: 'Vacío'
      //     })
      //   );
      // } else {

      if (isNaN(parseInt(this.value))) {
        value = this.value;
      }
      let displayValue;

      if (isNaN(parseInt(this.value))) {
        value = this.value;
        this.items$.pipe(take(1)).subscribe(items => {
          item = items.find(i => {
            return value === i;
          });
        });

        displayValue = item;
      } else {
        value = parseInt(this.value, 10);
        this.items$.pipe(take(1)).subscribe(items => {
          item = items.find(i => {
            return value === i[productField.key];
          });
        });
        displayValue = item[productField.display];
      }
      // }

      this.selectedFilter = {
        condition: this.key,
        valueCondition: this.value,
        keyName: productField.name,
        displayValue: displayValue
      };

      this.store.dispatch(new ProductActions.Filter(this.selectedFilter));

      this.filters.emit(this.selectedFilter);

      this.activeModal.dismiss(this.selectedFilter);
    }
    this.activeModal.close();
  }

  get seasonMode() {
    if (this.key === 'SeasonId') {
      this._bol = true;
      return this._bol;
    } else {
      this._bol = false;
      return this._bol;
    }
  }
}
